export default __webpack_public_path__ + "static/media/5.1cd7e309.jpg";